<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>




      <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit">
        <tab-content title="School Details" class="mb-5" icon="feather icon-home" :before-change="validateStep1">

          <form data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-full w-full mt-5">
                <vs-input label="DK CVR Number" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="School Name" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vue-dawa @select="selectItem($event, 'yourAddressObject')"
                  :val="yourAddressObject.oneLineAddress"
                  :showMax="5"
                  placeholder=""
                  containerId="schoolAddressContainer"
                  fieldClasses="vs-inputx vs-input--input normal w-full"
                  fieldId="your-field-id"
                  ref="your-field-id"
                  fieldName="your-field-name">
                  <label slot="label-top" for="field-2">School Address</label>
                </vue-dawa>
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="School Phone" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input type="email" label="School Email"  v-model="lastName" class="w-full" name="last_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.last_name') }}</span>
              </div>
            </div>

          </form>
        </tab-content>

        <tab-content title="Admin Details" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep2">
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="First Name" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="Last Name"  v-model="lastName" class="w-full" name="last_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.last_name') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="Phone" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="Email"  v-model="lastName" class="w-full" name="last_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.last_name') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="Password" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input label="Confirm Password"  v-model="lastName" class="w-full" name="last_name" v-validate="'required|alpha'" />
                <span class="text-danger">{{ errors.first('step-1.last_name') }}</span>
              </div>
            </div>
          </form>
        </tab-content>

        <tab-content title="Step 3" class="mb-5" icon="feather icon-image" :before-change="validateStep3">
          <form data-vv-scope="step-3">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input label="Event Name" v-model="eventName" class="w-full mt-5" name="event_name" v-validate="'required|alpha_spaces'" />
              <span class="text-danger">{{ errors.first('step-3.event_name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vs-select v-model="city" class="w-full select-large mt-5" label="Event Location">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in cityOptions" class="w-full" />
              </vs-select>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-select v-model="status" class="w-full select-large" label="Event Status">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in statusOptions" class="w-full" />
              </vs-select>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mt-8">
              <div class="demo-alignment">
                <span>Requirements:</span>
                <div class="flex">
                  <vs-checkbox>Staffing</vs-checkbox>
                  <vs-checkbox>Catering</vs-checkbox>
                </div>
              </div>
            </div>
          </div>
          </form>
        </tab-content>
      </form-wizard>



  </vx-card>
        </div>
    </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueDawa from '@ancaio/vue-dawa/sfc'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
    custom: {
        first_name: {
            required: 'First name is required',
            alpha: "First name may only contain alphabetic characters"
        },
        last_name: {
            required: 'Last name is required',
            alpha: "Last name may only contain alphabetic characters"
        },
        email: {
            required: 'Email is required',
            email: "Please enter valid email"
        },
        job_title: {
            required: 'Job title name is required',
            alpha: "Job title may only contain alphabetic characters"
        },
        proposal_title: {
            required: 'Proposal title name is required',
            alpha: "Proposal title may only contain alphabetic characters"
        },
        event_name: {
            required: 'Event name is required',
            alpha: "Event name may only contain alphabetic characters"
        },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    components: {
      FormWizard,
      TabContent,
      VueDawa
    },
    data() {
        return {
          yourAddressObject: {
      oneLineAddress: ''
    },
            firstName: "",
            lastName: "",
            email: "",
            city: "new-york",
            proposalTitle: "",
            jobTitle: "",
            textarea: "",
            eventName: "",
            eventLocation: "san-francisco",
            status: "plannning",
            cityOptions: [
                { text: "New York", value: "new-york" },
                { text: "Chicago", value: "chicago" },
                { text: "San Francisco", value: "san-francisco" },
                { text: "Boston", value: "boston" },
            ],
            statusOptions: [
                { text: "Plannning", value: "plannning" },
                { text: "In Progress", value: "in progress" },
                { text: "Finished", value: "finished" },
            ],
            LocationOptions: [
                { text: "New York", value: "new-york" },
                { text: "Chicago", value: "chicago" },
                { text: "San Francisco", value: "san-francisco" },
                { text: "Boston", value: "boston" },
            ],
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.first_name != '' && this.last_name != ''&& this.email != '' && this.password != '' && this.confirm_password != '' && this.isTermsConditionAccepted === true;
        }
    },
    methods: {
      selectItem (payload, objectName) {
   // this.$set(this, objectName, this.translateData(payload))
  },
      validateStep1() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll('step-1').then(result => {
                    if (result) {
                        resolve(true)
                    } else {
                        reject("correct all values");
                    }
                })
            })
        },
        validateStep2() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll("step-2").then(result => {
                    if (result) {
                        resolve(true)
                    } else {
                        reject("correct all values");
                    }
                })
            })
        },
        validateStep3() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll("step-3").then(result => {
                    if (result) {
                        alert("Form submitted!");
                        resolve(true)
                    } else {
                        reject("correct all values");
                    }
                })
            })
        },
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {

            // Close animation if passed as payload
            // this.$vs.loading.close()

            this.$vs.notify({
              title: 'Login Attempt',
              text: 'You are already logged in!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
          return true
        },
        registerUserJWt() {
          var self = this
          // this.$validator.validateAll().then(result => {
          //   if(result) {
          //     console.log("no")

          //   }else{
          //     console.log("yes")
          //   }
          // })

          // If form is not validated or user is already login return
          if (!this.validateForm || !this.checkLogin()) return

          this.$vs.loading({
            background: 'primary',
            color: '#fff',
            container: "#userRegisterBtn",
            scale: 0.45
          })

          const payload = {
            userDetails: {
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email,
              password: this.password,
              confirmPassword: this.confirm_password
            },
            notify: this.$vs.notify
          }

          this.$store.dispatch('auth/registerUserJWT', payload)
            .then((response) => { 
              this.$router.push('/dashboard').catch(() => {})
              
              this.$vs.notify({
                title: 'Hi '+this.first_name+' '+this.last_name,
                text: 'Your account successfully created',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })

              this.$vs.loading.close("#userRegisterBtn > .con-vs-loading")
            })
            .catch(error => {
              if(error.status == 422){
                Object.keys(error.data).forEach(function(key) {
                  self.errors.add({
                    field: key,
                    msg: error.data[key][0],
                  });
                });
              }

              this.$vs.loading.close("#userRegisterBtn > .con-vs-loading")
            })
        }
    }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
<style lang="css">
#schoolAddressContainer{
  position: relative;
  width: 100%;
  max-width: none;
}
</style>
